import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import PageLayout from "../components/PageLayout";
import { api } from "../lib/api";
import { useAuth, isClient, isAppraiser } from "../context/AuthContext";
import { ArrowRight, HouseLine } from "@phosphor-icons/react";

const STATUS_STYLES = {
  open: "bg-emerald-100 text-emerald-900",
  awarded: "bg-amber-100 text-amber-900",
  in_progress: "bg-sky-100 text-sky-900",
  submitted: "bg-indigo-100 text-indigo-900",
  in_review: "bg-violet-100 text-violet-900",
  approved: "bg-teal-100 text-teal-900",
  paid: "bg-green-200 text-green-900",
  cancelled: "bg-zinc-200 text-zinc-700",
};

export default function MyJobs({ scope = "mine", title = "My jobs", subtitle = "Appraisals you have ordered" }) {
  const { user } = useAuth();
  const [jobs, setJobs] = useState(null);

  useEffect(() => {
    (async () => {
      const { data } = await api.get(`/jobs?scope=${scope}`);
      setJobs(data);
    })();
  }, [scope]);

  return (
    <PageLayout>
      <div className="max-w-6xl">
        <div className="kicker">{isClient(user) && scope === "mine" ? "Client" : "Appraiser"}</div>
        <h1 className="display-serif text-4xl sm:text-5xl mt-2">{title}</h1>
        <p className="text-zinc-600 mt-3">{subtitle}</p>

        <div className="mt-10 grid gap-4">
          {jobs === null ? (
            <div className="text-zinc-500">Loading…</div>
          ) : jobs.length === 0 ? (
            <div className="surface-card p-8 text-zinc-600">Nothing yet.</div>
          ) : jobs.map(j => (
            <Link
              key={j.job_id}
              to={`/jobs/${j.job_id}`}
              data-testid={`job-row-${j.job_id}`}
              className="surface-card p-5 lg:p-6 flex flex-col sm:flex-row sm:items-center gap-4 hover:-translate-y-0.5 transition-transform duration-200"
            >
              <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-[#CCFBF1] text-[#115E59]">
                <HouseLine size={20} weight="duotone" />
              </span>
              <div className="flex-1">
                <div className="font-medium">{j.address}, {j.city} {j.state} {j.zip_code}</div>
                <div className="text-sm text-zinc-600 mt-0.5">
                  {j.form_type.replace("_", " ")} • {j.house_sqft || "?"} sqft • min ${j.ai_minimum_fee?.toFixed(0)}
                </div>
              </div>
              <span className={`chip ${STATUS_STYLES[j.status] || "bg-zinc-100"}`}>{j.status.replace("_", " ")}</span>
              <ArrowRight size={16} className="text-zinc-400" />
            </Link>
          ))}
        </div>
      </div>
    </PageLayout>
  );
}
